(function (w, d) {
  'use strict';
  var pixelId = 'PT6JXKJvcNgpZDA7niHJpK';
  var attemptKey = 'mast_oai_kitchen_attempt_v1';
  var pendingKey = 'mast_oai_kitchen_pending_v1';
  var maxAge = 30 * 60 * 1000;
  var loaded = false;
  var loading = false;
  var sent = false;

  function permitted() {
    try {
      var privacy = w.Shopify && w.Shopify.customerPrivacy;
      return !!privacy && privacy.marketingAllowed() === true &&
        privacy.saleOfDataAllowed() === true;
    } catch (error) { return false; }
  }

  function remove(key) {
    try { w.sessionStorage.removeItem(key); } catch (error) {}
  }

  function read(key) {
    try {
      var value = JSON.parse(w.sessionStorage.getItem(key));
      var age = value && Date.now() - value.createdAt;
      if (value && /^[a-f0-9-]{36}$/i.test(value.id) && age >= 0 && age < maxAge) return value;
    } catch (error) {}
    remove(key);
    return null;
  }

  function sendPending() {
    try {
      if (!loaded || sent || !permitted() || w.location.pathname !== '/pages/danke') return;
      var pending = read(pendingKey);
      if (!pending) return;
      w.oaiq('measure', 'lead_created', { type: 'customer_action' }, {
        event_id: pending.id,
        opt_out: true
      });
      sent = true;
      remove(pendingKey);
    } catch (error) {}
  }

  function loadPixel() {
    if (loaded || loading || !permitted() || pixelId.indexOf('__') === 0) return;
    if (w.oaiq) return;
    loading = true;
    var q = function () { q.q.push(arguments); };
    q.q = [];
    w.oaiq = q;
    q('consent', false);
    q('init', { pixelId: pixelId });
    var script = d.createElement('script');
    script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    script.onload = function () {
      try {
        loaded = true;
        loading = false;
        w.oaiq('consent', permitted());
        sendPending();
      } catch (error) {}
    };
    script.onerror = function () { loading = false; };
    d.head.appendChild(script);
  }

  function syncConsent() {
    try {
      var allowed = permitted();
      if (!allowed) {
        remove(attemptKey);
        remove(pendingKey);
      }
      if (w.oaiq) w.oaiq('consent', allowed);
      if (allowed) {
        loadPixel();
        sendPending();
      }
    } catch (error) {}
  }

  function bindForm() {
    var form = d.getElementById('mk-kitchen-form');
    if (!form || w.location.pathname !== '/pages/kuechenanfrage') return;
    form.addEventListener('submit', function () {
      try {
        remove(attemptKey);
        remove(pendingKey);
        if (!permitted() || !form.checkValidity() || !w.crypto.randomUUID) return;
        w.sessionStorage.setItem(attemptKey, JSON.stringify({
          id: w.crypto.randomUUID(),
          createdAt: Date.now()
        }));
      } catch (error) {}
    });
  }

  function start() {
    try {
      bindForm();
      d.addEventListener('visitorConsentCollected', syncConsent);
      if (w.Shopify && w.Shopify.customerPrivacy) syncConsent();
      else if (w.Shopify && w.Shopify.loadFeatures) {
        w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (!error) syncConsent();
        });
      }
    } catch (error) {}
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
